import { useEffect, useRef } from 'react';

/**
 * The hook manges onClick outside
 * @param onClickOutside 
 * @param exceptElementsWithDataEpo - when you want to except onClickOutside (recursive lists - see the component)
 * @returns 
 */
function useOnClickOutside(onClickOutside?: () => void | undefined, exceptElementsWithDataEpo?: { epoDataAttribute: string, epoDataAttributeValue: string }) {
    const ref = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent | TouchEvent) => {
            const localRef: any = ref.current;
            const target = (event.composedPath ? event.composedPath()[0] : event.target) as HTMLElement;

            if (localRef && !localRef.contains(event.target)) {
                if (exceptElementsWithDataEpo && target.getAttribute(exceptElementsWithDataEpo.epoDataAttribute) === exceptElementsWithDataEpo.epoDataAttributeValue) {
                    return;
                }

                onClickOutside && onClickOutside();
            }
        };
        document.addEventListener('click', handleClickOutside, true);

        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [exceptElementsWithDataEpo, onClickOutside]);

    return { ref };
}

export default useOnClickOutside;